<template>
    <b-container class="feature-page mb-4">
        <b-row>
            <b-col cols="6" order="2" order-md="1" md="3"  class="left-column">
                <div v-for="post in leftPosts" :key="post.id" class="left-post">
                    <b-link :to="'/' + post.category + '/' + post.id" >
                        <b-card
                            :title="post.title" 
                            :img-src="post.imgUrl" 
                            :img-alt="post.title" 
                            img-top style="max-width: 100%"
                            >
                            <b-card-text>
                                <div class="author-date">
                                    <ul>
                                        <li>
                                            <strong>{{post.author}}</strong>
                                        </li>
                                    </ul>
                                </div>
                            </b-card-text>
                        </b-card>
                    </b-link>
                    
                </div>
                    
            </b-col>
            <b-col cols="12" order="1" order-md="2" md="6" class="central-column">
                <b-link :to="'/' + centerPost.category + '/' + centerPost.id">
                    <b-card
                        :title="centerPost.title"
                        :img-src="centerPost.imgUrl"
                        :img-alt="centerPost.title"
                        img-top
                        tag="article"
                        style="max-width: 100%;"
                    >
                        <b-card-body>
                            <b-card-text v-html="centerPost.body.split(' ').slice(0, 30).join(' ') + '...'"></b-card-text>
                            <div class="author-date">
                                <ul>
                                    <li>
                                        <strong>{{centerPost.author}}</strong>
                                    </li>
                                </ul>
                            </div>
                        </b-card-body>
                        
                    </b-card>
                </b-link>
            </b-col>
            <b-col cols="6" md="3" order="3"  class="right-column">
                    <div v-for="post in rightPosts" :key="post.id" style="width: 100%" class="right-post">
                        <div style="width: 60%">
                             <b-link :to="'/' + post.category + '/' + post.id">
                                <b-card-body>
                                    <b-card-title >{{post.title}}</b-card-title>
                                    <div class="author-date">
                                        <ul>
                                            <li>
                                                <strong>{{post.author}}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                </b-card-body>
                             </b-link>
                        </div>
                        <div style="width: 40%">
                             <b-link :to="'/' + post.category + '/' + post.id">
                                <b-card-img 
                                    :src="post.imgUrl" 
                                    :img-alt="post.title" 
                                >
                                </b-card-img>
                             </b-link>
                        </div>
                </div>
            </b-col>
        </b-row>
        <hr>
    </b-container>
</template>

<script>
import { getSevenLatestPosts } from '../../firebase/posts';


export default {
    data() {
        return {
            centerPost: { body: '' },
            leftPosts: [],
            rightPosts: [],
        }
    },
    created() {
        getSevenLatestPosts().then(posts => {
            this.centerPost = posts[0]
            this.leftPosts = posts.slice(1,3)
            this.rightPosts = posts.slice(3,7)
        })
    },
}
</script>

<style lang="scss">
   @import '../../styles/components/home/FeaturePage.scss'
</style>

